import React, { useState, useContext, useEffect } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom';
import { ConfigProvider, theme, Switch, Layout, Menu } from 'antd';
import {
  TeamOutlined,
  TrophyOutlined,
  DashboardOutlined,
  OrderedListOutlined,
  ReadOutlined
} from '@ant-design/icons';
import ajaxMe from './ajax/me';
import UserInfoMenu from './components/UserInfoMenu';
import * as Settings from './utils/AuthUtils';
import { MeContext } from './context/';
import PublicRoutes from './routing/PublicRoutes';
import PrivateRoutes from './routing/PrivateRoutes';
import logo from './assets/LPI_LOGO_WHITE.png';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const { Header, Content, Footer } = Layout;
const { defaultAlgorithm, darkAlgorithm } = theme;

const basepath = process.env.PUBLIC_URL
  ? `${process.env.PUBLIC_URL}`
  : '/'; 

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [hasRights, setHasRights] = useState({isAdmin: false, isReferral: false});
  const me = useContext(MeContext);
  // console.warn('info me: ', me);

  useEffect(() => {
    const isAd = (me && me.payLoad ? me.payLoad.isAdmin : false)
    const isRef = Settings.isReferral(me && me.payLoad ? me.payLoad : {}); 
    setHasRights({isAdmin: isAd, isReferral: isRef});
  }, [me])

  function onChangeMode() {
    setIsDarkMode((previousValue) => !previousValue);
  }

  if (me && me.payLoad && me.payLoad.name !== '') {
    return (
      <ConfigProvider theme={{algorithm: isDarkMode ? darkAlgorithm : defaultAlgorithm, }}>
      <Router>
      <div className="App">
        <Layout className="layout" style={{minHeight:"100vh"}}>
          <Header>
            <div className="logo">
              <Link to={basepath} viewTransition>
                <img src={logo} height="48px" style={{ marginTop: '8px', marginRight: '16px', float: 'left' }}/> 
              </Link>
            </div>
            <Menu
              theme="dark"
              mode="horizontal"
              defaultSelectedKeys={['2']}
            >
              <Menu.Item key="/dashboard">
                  <Link to={`${basepath}dashboard`} className="no-link" viewTransition>
                  <DashboardOutlined /> Dashboard
                  </Link>
              </Menu.Item>
              <Menu.Item key="/leagues">
                <Link to={`${basepath}leagues`} className="no-link" viewTransition>
                    <TrophyOutlined /> Leagues
                </Link>
              </Menu.Item>
              <Menu.Item key="/seasons">
                <Link to={`${basepath}seasons`} className="no-link" viewTransition>
                    <TrophyOutlined /> Seasons
                </Link>
              </Menu.Item>
              <Menu.Item key="/tournaments">
                <Link to={`${basepath}tournaments`} className="no-link" viewTransition>
                    <TeamOutlined /> Tournaments
                </Link>
              </Menu.Item>
              {/* <Menu.SubMenu title="Tournaments" icon={<FontAwesomeIcon icon={faCalendarDays} />}>
                <Menu.Item key="tournaments/archive">
                  <Link to={`${basepath}tournaments`} className="no-link" viewTransition>
                      <TeamOutlined /> Archive
                  </Link>
                </Menu.Item>
              </Menu.SubMenu> */}
              <Menu.Item key="/ranking">
                <Link to={`${basepath}rankings`} className="no-link" viewTransition>
                  <OrderedListOutlined /> LPI Ranking
                </Link>
              </Menu.Item>
              <Menu.Item key="/rulebook">
                <Link to={`${basepath}rulebook`} className="no-link" viewTransition>
                  <ReadOutlined /> LPI Rulebook
                </Link>
              </Menu.Item>
              <Menu.Item key="/darkmodetoggle" className="user-menu item">
                Dark Mode: <Switch defaultChecked onChange={onChangeMode} />
              </Menu.Item>
              <Menu.Item key="/user" className="user-menu-item">
                <UserInfoMenu />
              </Menu.Item>
            </Menu>
          </Header>
          <Content>
            { /* <NavBreadcrumb /> */}
            <div className="site-layout-content">
              <PrivateRoutes basepath={basepath} hasRights={hasRights} />
            </div>
          </Content>
          <Footer style={{ textAlign: 'center' }}>
            Pauper League Manager ©2022 Created and maintained by <b>Paolo Iuculano</b><br/>
            It contains unofficial Fan Content permitted under the Fan Content Policy. Not approved/endorsed by Wizards. Portions of the materials used are property of Wizards of the Coast. <b>©Wizards of the Coast LLC.</b>
          </Footer>
        </Layout>
      </div>
      </Router>
      </ConfigProvider>
    );
  } else {
    // console.warn('atterro qua in app.js nella parte non autenticata!');
    return (
      <ConfigProvider theme={{algorithm: isDarkMode ? darkAlgorithm : defaultAlgorithm, }}>
      <Router>
      <div className="App">
        <Layout className="layout" style={{minHeight:"100vh"}}>
          <Header>
            <div className="logo">
              <Link to={basepath} viewTransition>
                <img src={logo} height="48px" style={{ marginTop: '8px', marginRight: '16px', float: 'left' }}/> 
              </Link>
            </div>
            <Menu
              theme="dark"
              mode="horizontal"
              defaultSelectedKeys={['2']}
            >
              <Menu.Item key="/leagues">
                <Link to={`${basepath}leagues`} className="no-link" viewTransition>
                    <TrophyOutlined /> Leagues
                </Link>
              </Menu.Item>
              <Menu.Item key="/seasons">
                <Link to={`${basepath}seasons`} className="no-link" viewTransition>
                    <TrophyOutlined /> Seasons
                </Link>
              </Menu.Item>
              <Menu.Item key="/tournaments">
                <Link to={`${basepath}tournaments`} className="no-link" viewTransition>
                    <TeamOutlined /> Tournaments
                </Link>
              </Menu.Item>
              <Menu.Item key="/ranking">
                <Link to={`${basepath}rankings`} className="no-link" viewTransition>
                  <OrderedListOutlined /> LPI Ranking
                </Link>
              </Menu.Item>
              <Menu.Item key="/rulebook">
                <Link to={`${basepath}rulebook`} className="no-link" viewTransition>
                  <ReadOutlined /> LPI Rulebook
                </Link>
              </Menu.Item>
              <Menu.Item key="/darkmodetoggle" className="user-menu item">
                Dark Mode: <Switch defaultChecked onChange={onChangeMode} />
              </Menu.Item>
              <Menu.Item key="/user" className="user-menu-item">
                <UserInfoMenu />
              </Menu.Item>
            </Menu>
          </Header>
          <Content>
            { /* <NavBreadcrumb /> */ }
            <div className="site-layout-content">
              <PublicRoutes basepath={basepath} hasRights={hasRights} />
            </div>
          </Content>
          <Footer style={{ textAlign: 'center' }}>
            Pauper League Manager ©2022 Created and maintained by <b>Paolo Iuculano</b><br/>
            It contains unofficial Fan Content permitted under the Fan Content Policy. Not approved/endorsed by Wizards. Portions of the materials used are property of Wizards of the Coast. <b>©Wizards of the Coast LLC.</b>
          </Footer>
        </Layout>
      </div>
      </Router>
      </ConfigProvider>
    )
  }
}

export default ajaxMe(App);

